var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keyboard_backspace"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.25 5.41667L7.15417 5.41667L5.6625 6.9125L6.25 7.5L8.75 5L6.25 2.5L5.6625 3.0875L7.15417 4.58333L1.25 4.58333L1.25 5.41667Z",
    fill: "#1B2559"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrowRightBlack.6352cb5c6fececf5d343f9341e013c01.svg";
export { ForwardRef as ReactComponent };